// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"200":"c68c3ab3","304":"f860e7ac","371":"a6732b43","880":"62ea333c"}[chunkId] + ".chunk.js";
};